import {Text} from "@mantine/core";
import {PropsWithChildren} from 'react';

export function CommandNameText(props: PropsWithChildren) {
    return (
        <Text size="1.3rem" fw={600} mt="lg" style={{color: "light-dark(#081317, #CFD4D6)"}}>
            {props.children}
        </Text>
    );
}